module.exports = __webpack_public_path__ + "../resources/img/storebadge_ko.e8e05f16.png";